import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getFunctions, httpsCallable } from "firebase/functions";

const ReferralSuccessPage = () => {
  const [referrerData, setReferrerData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const fetchReferrerData = async () => {
      const params = new URLSearchParams(location.search);
      const stripeAccountId = params.get("stripe_account_id");
      const token = params.get("token");

      if (stripeAccountId && token) {
        // Store the token in localStorage so the user can be "logged in" on return visits
        localStorage.setItem(`referrer_token_${stripeAccountId}`, token);

        try {
          const functions = getFunctions();
          const getReferrerData = httpsCallable(functions, "getReferrerData");
          const result = await getReferrerData({ stripeAccountId, token });
          setReferrerData(result.data);

          // Now that we have the data, trigger the onboarding email
          const sendEmail = httpsCallable(functions, "sendReferralOnboardingEmail");
          await sendEmail({ stripeAccountId, token });

        } catch (err) {
          setError("Could not retrieve your referral data. Please check the URL and try again.");
          console.error("Error fetching referrer data:", err);
        } finally {
          setLoading(false);
        }
      } else {
        // Check if we have a token in localStorage
        const storedToken = localStorage.getItem(`referrer_token_${stripeAccountId}`);
        if(stripeAccountId && storedToken) {
            // Re-run the fetch with the stored token
            const functions = getFunctions();
            const getReferrerData = httpsCallable(functions, "getReferrerData");
            getReferrerData({ stripeAccountId, token: storedToken })
                .then(result => setReferrerData(result.data))
                .catch(err => setError("Your session may have expired. Please use the original link."))
                .finally(() => setLoading(false));
        } else {
            setError("Your referral link is incomplete or invalid. Please use the link provided after signing up.");
            setLoading(false);
        }
      }
    };

    fetchReferrerData();
  }, [location]);

  if (loading) {
    return <div className="container" style={{ textAlign: "center", marginTop: "50px" }}>Loading...</div>;
  }

  if (error) {
    return <div className="container" style={{ textAlign: "center", marginTop: "50px", color: "red" }}>{error}</div>;
  }

  return (
    <div className="container" style={{ maxWidth: "600px", margin: "50px auto", textAlign: "center" }}>
      <h1>Your Referral Dashboard</h1>
      <p>Welcome! Here is your unique referral link. Share it to start earning.</p>

      <div style={{ margin: "30px 0" }}>
        <h3>Your Unique Referral Link</h3>
        <input
          type="text"
          value={referrerData?.referralLink}
          readOnly
          style={{ padding: "10px", width: "90%", borderRadius: "5px", border: "1px solid #ccc", textAlign: "center" }}
        />
        <button
          onClick={() => navigator.clipboard.writeText(referrerData?.referralLink)}
          className="pricing-button">
          Copy to Clipboard
        </button>
      </div>

      <div style={{ marginTop: "40px" }}>
        <h3>Your Performance</h3>
        <div style={{ fontSize: "1.2em" }}>
          <p>Successful Referrals: <strong>{referrerData?.conversions || 0}</strong></p>
        </div>
      </div>
       <p style={{marginTop: "30px", fontSize: "0.9em", color: "#666"}}>
        Bookmark this page! You can return here at any time to check your referral statistics.
      </p>
    </div>
  );
};

export default ReferralSuccessPage;